<template>
  <div class="row g-2 mb-4">
    <div class="col-md-3 col-sm-6" v-for="card in cards" :key="card.label">
      <div class="resumo-card h-100" :class="card.tone">
        <div class="resumo-label">{{ card.label }}</div>
        <div class="resumo-value">{{ card.value }}</div>
        <div class="resumo-sub">{{ card.sub }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  resumo: {
    type: Object,
    default: () => ({ banco: {}, operadora: {} })
  }
})

const cards = computed(() => [
  {
    label: 'Banco',
    value: props.resumo?.banco?.importados ?? 0,
    sub: `${props.resumo?.banco?.pendentes ?? 0} pendentes`,
    tone: 'tone-blue'
  },
  {
    label: 'Operadora',
    value: props.resumo?.operadora?.importados ?? 0,
    sub: `${props.resumo?.operadora?.pendentes ?? 0} pendentes`,
    tone: 'tone-purple'
  },
  {
    label: 'Conciliados',
    value: `${(props.resumo?.banco?.conciliados_automatico ?? 0)
      + (props.resumo?.banco?.conciliados_manual ?? 0)} banco`,
    sub: `${(props.resumo?.operadora?.conciliados_automatico ?? 0)
      + (props.resumo?.operadora?.conciliados_manual ?? 0)} vendas operadora`,
    tone: 'tone-green'
  },
  {
    label: 'Chargebacks',
    value: props.resumo?.operadora?.chargebacks ?? 0,
    sub: `${props.resumo?.operadora?.pendentes_ajuste ?? 0} pendentes ajuste`,
    tone: 'tone-amber'
  }
])
</script>

<style scoped>
.resumo-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 10px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
}

.resumo-label {
  font-size: 14px;
  color: #5b5d60;
  font-weight: 700;

  margin-bottom: 2px;
  line-height: 1.1;
}

.resumo-value {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.05;
  margin: 0;
}

.resumo-sub {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  line-height: 1.1;
}

.tone-blue { border-left: 4px solid #2563eb; }
.tone-purple { border-left: 4px solid #7c3aed; }
.tone-green { border-left: 4px solid #16a34a; }
.tone-amber { border-left: 4px solid #d97706; }

@media (max-width: 768px) {
  .resumo-card {
    padding: 8px 10px;
  }

  .resumo-value {
    font-size: 18px;
  }
}
</style>